// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"97218e37","149":"a5fecbca","189":"f8a2dde1","397":"0d335946","424":"b841037b","490":"e26ed671","518":"586b0d40","667":"3f44a247","781":"21fc5176"}[chunkId] + ".chunk.js";
};